import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
  {
    path: routeNames.rewardSetting,
    component: () => import('../../pages/rewardSetting/rewardSetting/list'),
    meta: { title: '悬赏帖时间设置' }
  }
] as TRoutes[]
